const safelyParseJson = <T>(jsonString: string): T => {
    try {
        return JSON.parse(jsonString) as T;
    } catch (error) {
        return [] as T;
    }
}

export default safelyParseJson;
